import GoodsDetail from './goods-detail'

export default GoodsDetail
